import React from "react";
import FlowBpmUiHost from "./FlowBpmUiHost";

const FlowBpmModelerHost = () => (
  <FlowBpmUiHost entry="/modeler/" title="iDynamicsAX Flow BPM Modeler" />
);

export default FlowBpmModelerHost;
